var Category = {
	init : function(luxcosSectId){		
		var _this = this;
		_this.luxcosSectId = luxcosSectId;
		
		$('#filter-category').on( "click", 'ul li> a' , function() {
			
			var obj = $(this);
			var categoryVal = obj.attr( "data-category" );
			
			if( categoryVal ){
				

				Filter.resetFilter( {} );
				SelectedFilters.reset();
				
				if(categoryVal === '0'){
					Filter.$filters["opt-category"].param = [];
				}else{
					Filter.$filters["opt-category"].param = [categoryVal];
				}
				
				$('[name=lastCategory]').parent().removeClass();
				obj.parent().attr('class', 'on');
			
				$('#filter-category').attr('data-category', categoryVal);
				HistoryManager.changeHash();	
				
			}
			
		});	
	},
	setSelected : function(){
		// 다시 그린 경우 , selected 가 선택 안된 경우가 있을수 있음
		var param = Filter.$filters["opt-category"].param;
		for( var inx in param ){
			var categories = param[inx].split("_");
			var depth = categories.length;
			
			var currentCate = param[inx];
			for( var jnx = 0; jnx < depth-1; jnx++){
				currentCate = currentCate.substring( 0 , currentCate.lastIndexOf("_") );
				if( !$("#category_"+currentCate).parent().hasClass("on") ){
					$("#category_"+currentCate).parent().addClass("on");
				}
			}									
		}		
	}
}